import { SUPPORT_TYPES } from './config'

export const initialState = {
  fullName: '',
  email: '',
  supportType: SUPPORT_TYPES[0].value,
  supportSubject: '',
  describeProblem: ''
}
